import script from "./formulaCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./formulaCategory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__